import React from 'react'

const Arrow = props => (
  <svg viewBox="0 0 564.16 165.73" {...props}>
    <path d="M481.3 165.74a8.14 8.14 0 0 1-5.75-13.87l60.86-60.86H8.13a8.13 8.13 0 1 1 0-16.26h528.28l-60.86-60.88a8.135 8.135 0 0 1 11.53-11.48l74.7 74.73a8.1 8.1 0 0 1 2.29 5.13 9 9 0 0 1 .01 1.62 8.11 8.11 0 0 1-1.95 4.33c-.13.15-.27.3-.41.44l-74.64 74.71a8.11 8.11 0 0 1-5.78 2.39z" />
  </svg>
)

export default Arrow



// WEBPACK FOOTER //
// ./src/components/shared/arrow.js